(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('showcase-layout-templates', {
                parent: 'showcases',
                url: '/layout-templates',
                data: {
                    authorities: ['STORE_READ_SHOWCASE'],
                    pageTitle: 'showcase-layout-template.title.list'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcase-layout-template/showcase-layout-template.html',
                        controller: 'ShowcaseLayoutTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: translatePartialLoader(['showcase-layout-template', 'showcases', 'flyers'])
                }
            })
            .state('showcase-layout-templates.new', {
                parent: 'showcase-layout-templates',
                url: '/new',
                data: {
                    authorities: ['STORE_CREATE_SHOWCASE'],
                    pageTitle: 'showcase-layout-template.title.create',
                    specialClass: 'fixed-sidebar md-skin fixed-nav'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcase-layout-template/showcase-layout-template-detail.html',
                        controller: 'ShowcaseLayoutTemplateDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: translatePartialLoader(['showcase-layout-template', 'showcases', 'flyers'])
                }
            })
            .state('showcase-layout-templates.edit', {
                parent: 'showcase-layout-templates',
                url: '/{templateId}',
                data: {
                    authorities: ['STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'showcase-layout-template.title.edit',
                    specialClass: 'fixed-sidebar md-skin fixed-nav'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcase-layout-template/showcase-layout-template-detail.html',
                        controller: 'ShowcaseLayoutTemplateDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: translatePartialLoader(['showcase-layout-template', 'showcases', 'flyers'])
                }
            });

        function translatePartialLoader(parts) {
            return ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('global');
                parts.forEach(function (part) {
                    $translatePartialLoader.addPart(part);
                });
                return $translate.refresh();
            }];
        }
    }

})();
